import './PostcardDeck.css';

const PostcardDeck = () => {
	return (
		<div className="postcard-deck">
			<div className="postcard-row">
				<div className="centered">
					<img src="/static/images/events/postcards/Feast.jpg" alt="Feast of St. Joseph AI Postcard" />
					<p className="highlight">The Feast Day of our Parish Patron!</p>
				</div>
				<div className="centered">
					<img src="/static/images/events/postcards/Garage.jpg" alt="Grandpa's Garage AI Postcard" />
					<p className="highlight">Our biggest fundraiser!</p>
				</div>
			</div>
			<div className="postcard-row">
				<div className="centered">
					<img src="/static/images/events/postcards/PAL.jpg" alt="PAL Lunch AI Postcard" />
					<p className="highlight">Serving the hungry!</p>
				</div>
				<div className="centered">
					<img src="/static/images/events/postcards/Crosses.jpg" alt="Pro-life Crosses AI Postcard" />
					<p className="highlight">Promoting the sanctity of life!</p>
				</div>
			</div>
		</div>
	);
};

export default PostcardDeck;